(() => {
  'use strict';
  function init(root) {
    if (!root || root.dataset.galleryReady === 'true') return;
    const stage = root.querySelector('.a9-stage');
    const rail = root.querySelector('.a9-thumbs');
    const slides = [...root.querySelectorAll('.a9-slide')];
    const thumbs = [...root.querySelectorAll('.a9-thumbs [data-slide]')];
    if (!stage || !slides.length) return;
    let index = 0, requested = null, drag = null, frame = 0, timer;
    let width = stage.clientWidth;
    const nearest = () => Math.max(0, Math.min(slides.length - 1, Math.round(stage.scrollLeft / (stage.clientWidth || 1))));
    const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function paint(i) {
      index = i;
      slides.forEach((slide, n) => {
        slide.setAttribute('aria-hidden', String(n !== i));
        if (Math.abs(n - i) <= 1) slide.querySelector('img').loading = 'eager';
      });
      thumbs.forEach((thumb, n) => {
        thumb.setAttribute('aria-selected', String(n === i));
        thumb.tabIndex = n === i ? 0 : -1;
      });
      const active = thumbs[i];
      if (rail && active) {
        const r = rail.getBoundingClientRect(), b = active.getBoundingClientRect();
        if (b.left < r.left) rail.scrollLeft += b.left - r.left;
        else if (b.right > r.right) rail.scrollLeft += b.right - r.right;
      }
    }
    function go(i, focus = false, instant = false) {
      requested = (i + slides.length) % slides.length;
      paint(requested);
      stage.scrollTo({left: requested * stage.clientWidth, behavior: instant || reduced() ? 'instant' : 'smooth'});
      if (focus) thumbs[requested]?.focus({preventScroll: true});
    }
    function settle() {
      if (drag) return;
      requested = null;
      paint(nearest());
    }
    stage.addEventListener('scroll', () => {
      if (!frame) frame = requestAnimationFrame(() => {
        frame = 0;
        if (requested === null) paint(nearest());
      });
      clearTimeout(timer);
      timer = setTimeout(settle, 140);
    }, {passive: true});
    stage.addEventListener('scrollend', settle);
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => go(i)));
    function keys(event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const current = requested === null ? nearest() : requested;
      go(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1), event.currentTarget !== stage, event.key === 'Home' || event.key === 'End');
    }
    stage.addEventListener('keydown', keys);
    rail?.addEventListener('keydown', keys);
    // Touch/trackpad scrolling is native, so images follow the finger before release.
    // Mouse dragging supplements native scrolling without intercepting touch or page pan.
    stage.addEventListener('pointerdown', event => {
      requested = null;
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      drag = {id: event.pointerId, x: event.clientX, left: stage.scrollLeft};
      stage.classList.add('a10-dragging');
      stage.setPointerCapture(event.pointerId);
      stage.focus({preventScroll: true});
      event.preventDefault();
    });
    stage.addEventListener('pointermove', event => {
      if (drag && event.pointerId === drag.id) stage.scrollLeft = drag.left + drag.x - event.clientX;
    });
    function endDrag(event) {
      if (!drag || drag.id !== event.pointerId) return;
      const target = nearest();
      drag = null;
      stage.classList.remove('a10-dragging');
      if (stage.hasPointerCapture(event.pointerId)) stage.releasePointerCapture(event.pointerId);
      go(target);
    }
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);
    stage.addEventListener('dragstart', event => event.preventDefault());
    new ResizeObserver(() => {
      if (stage.clientWidth && stage.clientWidth !== width) {
        width = stage.clientWidth;
        go(index, false, true);
      }
    }).observe(stage);
    stage.setAttribute('role', 'region');
    stage.setAttribute('aria-roledescription', 'carousel');
    stage.setAttribute('aria-label', 'Product images. Swipe or use left and right arrow keys.');
    paint(0);
    root.dataset.galleryReady = 'true';
  }
  function boot() { document.querySelectorAll('[data-a10]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true});
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
